import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";


type Props = {
  onActionEditar: ( Id: number | null, openState: boolean) => void,
  onActionDeletar: ( Id: number | null, openState: boolean) => void,
};

export const GenerateQualidadeItemProcessosInteresseColumns = ({
  onActionEditar,onActionDeletar,
}: Props): GridColDef[] => {

  return [
    {
      field: "Descricao", 
      filterable: false,
      headerName: "Partes Interessadas", 
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "Expectativa",
      filterable: false,
      headerName: "Necessidade e Expectativa",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "Acompanhamento",
      filterable: false,
      headerName: "Acompanhamento",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "ResultadosAlcancados",
      filterable: false,
      headerName: "Resultados Alcançados",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
    field: 'IdItemProcessoInteresse',
    sortable: false,
    filterable: false,
    headerName: 'Ações',
    width: 120,

    renderCell: (params) => {
      return (
        <div className="flex items-center justify-center w-full h-full gap-1">
          <IconButton onClick={() => onActionEditar(params.value, true)}>
            <DynamicIcon nameIcon="EditRounded" size={22} className="dark:text-white text-primary-green" />
          </IconButton>
          <IconButton onClick={() => onActionDeletar(params.value, true)} >
            <DynamicIcon nameIcon="DeleteForeverRounded" size={22} className="text-red-500" />
          </IconButton>

        </div>
      );
    }
    },
  ];
}